var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
/**
 * A read-only field component that displays a label and value.
 *
 * @element kr-detail-field
 */
export class KRDetailField extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * The field label text
         */
        this.label = '';
        /**
         * The value to display
         */
        this.value = '';
    }
    render() {
        // A blank value shows an italicized "None" placeholder so an empty field reads as
        // intentionally empty rather than looking like a rendering gap.
        let isEmpty = false;
        if (this.value === '' || this.value === null || this.value === undefined) {
            isEmpty = true;
        }
        let content = this.value;
        if (isEmpty) {
            content = 'None';
        }
        return html `
      <div class="wrapper">
        ${this.label
            ? html `<label>${this.label}</label>`
            : nothing}
        <div class=${classMap({
            value: true,
            'value--empty': isEmpty,
        })}>${content}</div>
      </div>
    `;
    }
}
KRDetailField.styles = css `
    :host {
      display: block;
      font-family: inherit;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    label {
      font-size: 14px;
      font-weight: 500;
      color: black;
    }

    .value {
      font-size: 14px;
      color: black;
    }

    .value--empty {
      font-style: italic;
    }
  `;
__decorate([
    property({ type: String })
], KRDetailField.prototype, "label", void 0);
__decorate([
    property({ type: String })
], KRDetailField.prototype, "value", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell loads krubble globally while an embedded app bundled its
// own copy) doesn't throw. First definition wins.
if (!customElements.get('kr-detail-field')) {
    customElements.define('kr-detail-field', KRDetailField);
}
//# sourceMappingURL=detail-field.js.map